import { NavLink, Outlet } from 'react-router-dom';
import { useSession } from '../lib/session';
import { FeedbackPopup } from './FeedbackPopup';
import { Brand } from './Brand';
import { ImpersonationBanner } from './ImpersonationBanner';
import { CompleteWinningPayment } from './CompleteWinningPayment';
import './AppShell.css';

const LANDING_URL =
  import.meta.env.PUBLIC_LANDING_URL || 'https://converted-closet-website.pages.dev';

export function AppShell() {
  const { profile } = useSession();

  return (
    <div className="shell">
      <ImpersonationBanner />
      <CompleteWinningPayment />

      <nav className="shell__nav" aria-label="Primary">
        <div className="container shell__nav-inner">
          <NavLink to="/" className="shell__brand">
            <img src="/logos/cc-logo-header.png" alt="CONVERTED CLOSET" />
          </NavLink>

          <div className="shell__links">
            <NavLink to="/" end>Closets</NavLink>
            <NavLink to="/sales-room">Saleroom</NavLink>
            <NavLink to="/calendar">Calendar</NavLink>
            <NavLink to="/profile">Profile</NavLink>
            {(profile?.role === 'admin' || profile?.role === 'developer') && (
              <NavLink to="/admin">Admin</NavLink>
            )}
          </div>
        </div>
      </nav>

      <main className="shell__main">
        <Outlet />
      </main>

      <footer className="shell__footer">
        <div className="container shell__footer-inner">
          <a href={LANDING_URL} className="shell__footer-link" target="_blank" rel="noopener noreferrer">
            ← convertedcloset.com
          </a>
          <span className="shell__footer-legal">© 2026 <Brand /></span>
        </div>
      </footer>

      <FeedbackPopup />
    </div>
  );
}
